// axios
import axios from 'axios'

// const domain = "http://127.0.0.1:8000"
const domain = "https://backend.tittam.com/public"

export default axios.create({
	baseURL : domain
})
